import React from 'react';
import { useNavigate } from 'react-router-dom';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import environnement from 'components/config//Environnement';

import 'styles/Login.css';
import logo from 'imgs/logo.jpg';
import 'bootstrap/dist/css/bootstrap.css';

const Login = (props) => {
  const { children } = props;
  const navigate = useNavigate();

  return (
    <div className="main-login">
      <div className="Login">
        <div className="Login-box">
          <div className="Login-logo"><a onClick={() => navigate('/authentification')}><img src={logo} alt="Promete'a" /></a></div>
          <div className="Login-title">Staff'In</div>
          {(Number(environnement.id) > 100) &&
            <Stack spacing={1} alignItems="center" sx={{ marginTop: '20px' }}>
              <Stack direction="row" spacing={1}>
                <Chip label={environnement.label} color={environnement.color} style={{ fontFamily: 'Poppins', backgroundColor: '#326ea0' }} />
              </Stack>
            </Stack>
          }
          {children}
        </div>
      </div>
    </div>
  );
}

export default Login;
